<div
  [ngClass]="{
    'iris-text-input-animation-container': !isReadonly,
    'input-with-icon': hasIcon,
    'icon-left': (hasIcon && !iconRightAligned),
    'icon-right': (hasIcon && iconRightAligned),
    'input-with-button': hasButton
  }">
  <ng-container *ngIf="type === 'number'; else textInput">
    <input
      #irisInputElement
      class="iris-text-input"
      type="number"
      [formControl]="control"
      [id]="formControlName"
      [name]="formControlName"
      [attr.aria-describedby]="formControlName
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [attr.autocomplete]="autocomplete"
      [attr.required]="(control | isControlRequired) || null"
      [ngClass]="{'invalid': control.touched | isControlInvalidAndTouched:control.invalid}"
      [placeholder]="placeholder"
      [readonly]="isReadonly"
      [min]="(min ?? '')"
      [max]="(max ?? '')"
      [step]="(step ?? 1)"
    />
  </ng-container>
  <ng-template #textInput>
    <input
      #irisInputElement
      class="iris-text-input"
      [type]="type"
      [formControl]="control"
      [id]="formControlName"
      [name]="formControlName"
      [attr.aria-describedby]="formControlName
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [attr.autocomplete]="autocomplete"
      [attr.required]="(control | isControlRequired) || null"
      [ngClass]="{'invalid': control.touched | isControlInvalidAndTouched:control.invalid}"
      [placeholder]="placeholder"
      [readonly]="isReadonly"
      [maxlength]="maxLength"
      [mask]="mask || ''"
      [dropSpecialCharacters]="mask ? dropSpecialCharacters : null"
    />
  </ng-template>
  <ng-content *ngIf="hasIcon || hasButton"></ng-content>
</div>
